var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'businesstype-edit',
  created () {
    this.$store.dispatch('USERTYPE_ALL_GET', {})

    this.search()
  },
  data () {
    return {
      canValidate: true,
      contentCount: 0,
      business_type: {
        user_type_id: null,
        business_type_content: null,
      }
    }
  },
  computed: {
    usertypes () {
      return this.$store.getters.usertypesAll
    },
    businesstype () {
      return this.$store.getters.edit_business_type
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    validation: function() {
      var v = {
        user_type_id: !!this.businesstype.data.attributes['user-type-id'],
        business_type_content: !!this.businesstype.data.attributes['business-type-content'],
        not_input: !!this.businesstype.data.attributes['user-type-id'] && !!this.businesstype.data.attributes['business-type-content']
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }

  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      this.canValidate = true
      if (this.isValid) {
        console.log("is valid")
        var data = {
          user_type_id: this.businesstype.data.attributes['user-type-id'],
          business_type_content: this.businesstype.data.attributes['business-type-content']
        }
        this.$store.dispatch('BUSINESS_TYPE_UPDATE', { id: this.$route.params.id, data: data, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/business_types', query: { type: this.$router.currentRoute.query.type}})
    },
    search: function() {
      var data = {}
      var self = this
      var callback = function () {
        self.contentCounter()
      }
      this.$store.dispatch('BUSINESS_TYPE_EDIT',  {id: this.$route.params.id, data: data, callback: callback})
    },
    half: function () {
      this.businesstype.data.attributes['business-type-content'] = utils.emHalf(this.businesstype.data.attributes['business-type-content'])
    },
    onSaved: function (result) {
      this.$router.push({ path: '/business_types/'})
    },
    contentCounter: function() {
      this.half()
      this.contentCount = this.businesstype.data.attributes['business-type-content'].length
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/businesstype-edit.js